import styled, { css } from 'styled-components';
import { media } from '@/styles/responsive';
import ExecutedIcon from './images/ExecutedIcon.svg?react';
import SentIcon from './images/SentIcon.svg?react';
import CancelledIcon from './images/CancelledIcon.svg?react';

const mobileIcon = css`
  ${media.mobile`
    width: 150px;
    height: 150px;
  `}
`;

export const WaterMarkWrapper = styled.div`
  position: absolute;
  left: 50%;
  bottom: -100px;
  margin-left: -100px;
  z-index: 1;

  ${media.mobile`
    bottom: -75px;
    margin-left: -75px;
  `}
`;

export const ExecutedIconWrapper = styled(ExecutedIcon)`
  ${mobileIcon};
`;

export const SentIconWrapper = styled(SentIcon)`
  ${mobileIcon};
`;
export const CancelledIconWrapper = styled(CancelledIcon)`
  ${mobileIcon};
`;
